import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type JournalistEnquiry from "./JournalistEnquiry";
import type User from "./User";

@Model()
class JournalistEnquiriesUser extends ApplicationRecord {
  static jsonapiType = "journalist_enquiries_users";

  @BelongsTo() journalistEnquiry: JournalistEnquiry;

  @Attr() journalistEnquiryId: number;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default JournalistEnquiriesUser;
